import React, { Fragment } from 'react';
import styled from 'styled-components';
import { IRowMeta } from '../../../redux/slices/oldBuilder';
import { notEqualSign } from '../../../utils/charCodeSigns';
import { isEmptyEventCondition } from '../../../utils/builder';
import * as BuilderUI from '../BuilderUI';
import { EventCondition } from '../BuilderFields/EventConditions';
import { IEventConditionFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { byTypeName } from '../../../utils/types';
import { theme } from '../../../styles/theme';

interface IProps {
  rowMeta: IRowMeta;
  eventConditions: IEventConditionFieldsFragment[];
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 4px;
  width: 100%;
`;

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

const DividerWrapper = styled.div`
  padding-left: 4px;
`;

const Label = styled(BuilderUI.InputLabel)`
  position: relative;
  margin-top: 10px;
  padding-left: 4px;
  line-height: normal;
`;

const ExcludeIcon = styled.div`
  position: absolute;
  top: 6px;
  left: -9px;
  font-weight: 600;
  font-size: 16px;
  line-height: 0;
  color: ${theme.colors.secondary800};
`;

const ExcludedEventConditions = ({ rowMeta, eventConditions }: IProps) => {
  const { rowType, rowIndex } = rowMeta;

  return (
    <Container>
      <Label>
        <ExcludeIcon>{notEqualSign}</ExcludeIcon>
        Event(s)
      </Label>
      <Wrapper>
        {eventConditions.map((eventCondition, eventIndex) => {
          const virtualEvents = eventCondition.events.filter(
            byTypeName('VirtualEvent'),
          );
          const canRenderFilters =
            !isEmptyEventCondition(eventCondition) && !virtualEvents?.length;

          return (
            <Fragment
              key={`${rowType}-${rowIndex}-${eventIndex}-excluded-event`}
            >
              {eventIndex > 0 && (
                <DividerWrapper>
                  <BuilderUI.HorizontalDivider />
                </DividerWrapper>
              )}
              <EventCondition
                rowMeta={{ ...rowMeta, negativeStepRowIndex: eventIndex }}
                filter={eventCondition?.filter}
                canRenderRemove={true}
                canRenderFilters={canRenderFilters}
              />
            </Fragment>
          );
        })}
      </Wrapper>
    </Container>
  );
};

export default ExcludedEventConditions;
